import React from 'react';
import { AutoSizeCard } from './autoSizeCard';
import { ReactComponent as InfoIcon } from './../../../assets/icons/info.svg';
import styles from './infoCard.module.css';

/**
 * @param {Object} props
 * @param {JSX.Element|string} props.title Title
 * @param {JSX.Element|JSX.Element[]} props.children Children
 */
export const InfoCard = ({title = <></>, children}) => {

    return <AutoSizeCard
        className={styles.InfoCard}
    >
        <h1>
            <div className='icon'><InfoIcon /></div>
            {title}
        </h1>
        <div className={styles.Body}>{children}</div>
    </AutoSizeCard>
}